import { RoleLabelsMap } from './types'

export const roleLabelsMap: RoleLabelsMap = {
  admin: {
    label: 'Super Admin',
    chipColor: 'primary',
  },
  adminLimited: {
    label: 'Administrador',
    chipColor: 'default',
  },
  employee: {
    label: 'Empleado',
    chipColor: 'default',
  },
  marketing: {
    label: 'Marketing',
    chipColor: 'default',
  },
  analyst: {
    label: 'Analista',
    chipColor: 'default',
  },
}
